module.exports = __webpack_public_path__ + "img/kxy.dada0190.jpg";